<template>
  <el-dialog
    :visible.sync="visibleProxy"
    :title="isEdit ? 'Chỉnh sửa gói giới hạn' : 'Thêm gói giới hạn'"
    width="520px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div class="ps-dialog-intro">
      <div class="ps-dialog-intro__icon"><i class="el-icon-box" /></div>
      <div>
        <h3>{{ isEdit ? 'Cập nhật thông tin gói' : 'Tạo gói mới cho hệ thống' }}</h3>
        <p>Giới hạn được tính theo số học sinh đang học tại mỗi trường. Mã gói sẽ do hệ thống tự sinh.</p>
      </div>
    </div>

    <el-form
      ref="packageForm"
      :model="form"
      :rules="rules"
      label-position="top"
      class="ps-dialog-form"
    >
      <el-form-item v-if="isEdit" label="Mã gói">
        <el-input :value="editingPackage.code" disabled>
          <i slot="prefix" class="el-icon-price-tag" />
        </el-input>
        <span class="ps-form-hint">Mã gói được backend sinh tự động và không thể chỉnh sửa.</span>
      </el-form-item>

      <el-form-item label="Tên gói" prop="name">
        <el-input
          v-model="form.name"
          maxlength="80"
          show-word-limit
          clearable
          placeholder="VD: Gói Phát triển"
        />
      </el-form-item>

      <el-form-item label="Số giới hạn học sinh" prop="limit">
        <el-input-number
          v-model="form.limit"
          :min="1"
          :max="100000"
          controls-position="right"
          class="ps-full-width"
        />
        <span class="ps-form-hint">Chỉ nhận số nguyên dương. Add-on sẽ được cộng riêng tại từng trường.</span>
      </el-form-item>
    </el-form>

    <span slot="footer" class="ps-dialog-footer">
      <el-button @click="visibleProxy = false">Hủy</el-button>
      <el-button type="primary" :loading="saving" @click="handleConfirm">
        <i class="el-icon-check" /> {{ isEdit ? 'Lưu thay đổi' : 'Tạo gói' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "PackageFormDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editingPackage: {
      type: Object,
      default: null,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: "",
        limit: 100,
      },
      rules: {
        name: [
          { required: true, message: "Vui lòng nhập tên gói", trigger: "blur" },
        ],
        limit: [
          { required: true, message: "Vui lòng nhập số giới hạn", trigger: "change" },
          { validator: (rule, value, callback) => {
            if (!Number.isInteger(value) || value <= 0) {
              callback(new Error("Giới hạn phải là số nguyên dương"));
              return;
            }
            callback();
          }, trigger: "change" },
        ],
      },
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    isEdit() {
      return Boolean(this.editingPackage);
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.form = this.editingPackage
        ? {
          name: this.editingPackage.name,
          limit: this.editingPackage.limit,
        }
        : { name: "", limit: 100 };
      this.$nextTick(() => {
        if (this.$refs.packageForm) {
          this.$refs.packageForm.clearValidate();
        }
      });
    },
    handleConfirm() {
      this.$refs.packageForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", { ...this.form });
        }
      });
    },
  },
};
</script>
